import React from 'react'
import {Modal} from 'common/modals'
import {Button} from 'common/buttons'
import Form, {Textarea} from 'form'
import {reportContent} from 'utils'

/**
 * Report an inappropriate post. Collects a reason and hands it to the shared
 * reporting mechanism (currently a pre-filled email; Jira later — see utils/report).
 */
export function ReportPostModal(props: any)
{
	const {post, close} = props

	const onSubmit = (data: any) => {
		reportContent('Post', post.id, data?.message ?? '')
		close()
	}

	return (
		<Modal {...props}>
			<Form onSubmit={onSubmit}>
				<div className="modal-body">
					<div>
		      	<h2>
		      		<small className="text-muted">Report Post</small><br/>
		      		What bothers you about this post?
		      	</h2>
		      </div>
		      <Textarea
		      	name="message"
		      	placeholder="Describe the problem"
		      	rules={{
		      		required: 'Please describe what the problem with this post is'
		      	}}
		      />
		    </div>
		    <div className="modal-footer">
		      <Button variant="outline-secondary" type="reset" onClick={close}>Cancel</Button>
		      <Button variant="outline-secondary" type="submit">Report</Button>
		    </div>
		  </Form>
		</Modal>
	)
}
